import React, { useState, useContext } from 'react';
import { Paper, Typography, InputBase, IconButton, Select } from '@mui/material';
import Grid from '@mui/material/Grid';
import SearchIcon from '@mui/icons-material/Search';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { HomeContext } from '../utils/contexts/homeContext';

export default function ServiceSearchHeader(props) {
    const { handleServiceSearchClick } = props;
    const { homeState } = useContext(HomeContext);

    const [searchBy, setSearchBy] = React.useState('nurse');
    const [searchIn, setSearchIn] = React.useState('all');
    const [searchText, setSearchText] = useState('');

    React.useEffect(() => {
        if (homeState.patientServiceSearchText.includes('?is-show-all=true')) {
            setSearchIn('all');
        } else if (homeState.patientServiceSearchText.includes('?is-show-all=false')) {
            setSearchIn('active_only');
        }

        let searchTextIndex = -1;
        let tempSearchInLen = 0;
        if (homeState.patientServiceSearchText.includes('&nurse=')) {
            searchTextIndex = homeState.patientServiceSearchText.indexOf('&nurse=');
            tempSearchInLen = '&nurse='.length;
            setSearchBy('nurse');
        } else if (homeState.patientServiceSearchText.includes('&patient_name=')) {
            searchTextIndex = homeState.patientServiceSearchText.indexOf('&patient_name=');
            tempSearchInLen = '&patient_name='.length;
            setSearchBy('patient_name');
        } else if (homeState.patientServiceSearchText.includes('&place=')) {
            searchTextIndex = homeState.patientServiceSearchText.indexOf('&place=');
            tempSearchInLen = '&place='.length;
            setSearchBy('place');
        } else if (homeState.patientServiceSearchText.includes('&patient_phone=')) {
            searchTextIndex = homeState.patientServiceSearchText.indexOf('&patient_phone=');
            tempSearchInLen = '&patient_phone='.length;
            setSearchBy('patient_phone');
        }

        if (searchTextIndex > -1) {
            setSearchText(homeState.patientServiceSearchText.substring(searchTextIndex + tempSearchInLen));
        }

    }, []);

    const handleSearchInChange = (event) => {
        setSearchIn(event.target.value);
    };

    const handleSearchByChange = (event) => {
        setSearchBy(event.target.value);
    };

    const handleSearchClick = () => {
        const tempSearchText = searchText.trim();
        //let searchQuery = '?is-show-all=' + (searchIn !== 'active_only' ? 'true' : 'false');
        let searchQuery = '?is-show-all=' + (tempSearchText.length > 0 ? 'true' : 'false');
        searchQuery += tempSearchText.length > 0 ? '&' + searchBy + '=' + tempSearchText : '';

        handleServiceSearchClick(searchQuery);
    }

    return (

        <Paper>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="stretch"
            >
                <Grid size={2}>
                    <Typography variant="h5" sx={{ p: 2 }}>
                        Services
                    </Typography>
                </Grid>
                <Grid size={9}>
                    <Grid container spacing={0.5} sx={{ mt: 1 }}>
                        {/* <Grid size={2}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="demo-select-search-in">Search In</InputLabel>
                                <Select labelId="demo-select-search-in"
                                    label="Search In" value={searchIn} onChange={handleSearchInChange}
                                >
                                    <MenuItem value={"all"}>All</MenuItem>
                                    <MenuItem value={"active_only"}>Active Only</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid> */}
                        <Grid size={2}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="demo-select-search-by">Search By</InputLabel>
                                <Select labelId="demo-select-search-by"
                                    label="Search By" value={searchBy} onChange={handleSearchByChange}
                                >
                                    <MenuItem value={"nurse"}>Nurse Name</MenuItem>
                                    <MenuItem value={"patient_name"}>Patient Name</MenuItem>
                                    <MenuItem value={"place"}>Patient Place</MenuItem>
                                    <MenuItem value={"patient_phone"}>Patient Phone</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid size={10}>
                            <Paper variant="outlined"
                                sx={{ display: 'flex', alignItems: 'center' }}
                            >
                                <InputBase value={searchText}
                                    sx={{ ml: 1, flex: 1 }}
                                    placeholder="Search Service"
                                    onChange={(event) => {
                                        setSearchText(event.target.value);
                                    }}
                                />
                                <IconButton type="button" sx={{ p: '7px' }} aria-label="search service" onClick={handleSearchClick}>
                                    <SearchIcon />
                                </IconButton>
                            </Paper>
                        </Grid>

                    </Grid>

                </Grid>
                <Grid size={1}>

                </Grid>
            </Grid>
        </Paper>

    );
}